import React, { Component, createContext, ReactNode, useContext } from 'react';

// Exceptions thrown in event handlers can't be handled by React's getDerivedStateFromError system.  Thus, we have to
//   use this component with a built-in componentDidCatch along with this error reporting context to handle exceptions
//   from event handlers.
const ErrorReportingContext = createContext<(error: unknown) => void>(() => {});
export const useErrorReporter = () => useContext(ErrorReportingContext);

interface Props {
  readonly children: ReactNode;
  readonly onError: (error: unknown) => void;
}

export class ErrorBarrier extends Component<Props> {
  componentDidCatch(error: unknown) {
    this.props.onError(error);
  }

  render() {
    return (
      <ErrorReportingContext.Provider value={this.props.onError}>{this.props.children}</ErrorReportingContext.Provider>
    );
  }
}
